import { render, staticRenderFns } from "./About1.vue?vue&type=template&id=713c8108&"
import script from "./About1.vue?vue&type=script&lang=js&"
export * from "./About1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports